import React from 'react'

import {
    Edit,
    required,
    SimpleForm,
    useTranslate,
    useInput,
} from 'react-admin'

import { Box, Switch, Typography, useTheme } from '@mui/material';
import NavigateBackBtn from '../../../ui/button/NavigateBackBtn';
import MacAddressFieldsGrid from '../MacAddressFieldsGrid';
import { PickLocationButton } from '../LocationPickerInput';



const validateRequired = [required('Champs obligatoire')]

const STATUS_ALLOWED = 'ALLOWED'
const STATUS_BLOCKED = 'BLOCKED'

const StatusSwitchInput = ({ source }) => {
    const theme = useTheme();
    const translate = useTranslate();
    const { field } = useInput({ source });
    const isAllowed = field.value === STATUS_ALLOWED;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: '0px 0px 16px 0px' }}>
            <Typography sx={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 500,
                color: !isAllowed ? theme.palette.error.main : theme.palette.text.secondary,
            }}>
                {translate('resources.mac_addresses.status_blocked')}
            </Typography>
            <Switch
                checked={isAllowed}
                onChange={(e) => field.onChange(e.target.checked ? STATUS_ALLOWED : STATUS_BLOCKED)}
                color="success"
            />
            <Typography sx={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 500,
                color: isAllowed ? theme.palette.success.main : theme.palette.text.secondary,
            }}>
                {translate('resources.mac_addresses.status_allowed')}
            </Typography>
        </Box>
    );
};

const MacAddressEdit = () => {
    const translate = useTranslate();
    const theme = useTheme();


    const inputsDataGeneral = [
        { name: 'mac_address', label: translate('resources.mac_addresses.fields.mac_address'), validate: validateRequired, type: "text", fullWidth: true },
        { name: 'address.latitude', label: translate('resources.mac_addresses.fields.latitude'), validate: validateRequired, type: "number" },
        { name: 'address.longitude', label: translate('resources.mac_addresses.fields.longitude'), validate: validateRequired, type: "number" },
        { name: 'address.formatted_address', label: translate('resources.mac_addresses.fields.formatted_address'), validate: validateRequired, type: "text" },
        { name: 'address.country', label: translate('resources.mac_addresses.fields.country'), type: "text" },
        { name: 'address.city', label: translate('resources.mac_addresses.fields.city'), type: "text" },
        { name: 'address.postcode', label: translate('resources.mac_addresses.fields.postcode'), type: "text" },
       
    ]


    return (
        <>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 16px 0px" }}>
                <NavigateBackBtn /> {translate('resources.mac_addresses.edit')}
            </Typography>
            <Edit
                redirect="list"
                title={'resources.mac_addresses.edit'}
                sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                    },
                }}
                
            >

                <SimpleForm>
                
                   <Typography color="text.main" sx={{
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "25px",
                        textAlign: "center",
                        margin: "0px 0px 10px 0px"
                    }}
                    >
                        {translate('resources.vouchers.sections.general')}
                    </Typography>
                    <MacAddressFieldsGrid inputsData={inputsDataGeneral} />

                    <PickLocationButton />

                    <Typography color="text.main" sx={{
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        textAlign: "center",
                        margin: "0px 0px 8px 0px"
                    }}
                    >
                        {translate('resources.mac_addresses.fields.status')}
                    </Typography>
                    <StatusSwitchInput source="status" />
                </SimpleForm>
            </Edit>
        </>
    )
}

export default MacAddressEdit







